export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },
  token: (state) => {
    return state.token;
  },

  checkNewRegister: (state) => {
    return state.checkNewRegister;
  },

  captcha: (state) => {
    return state.captcha;
  },
  
  loadingBtn: (state) => {
    return state.loadingBtn;
  },

  imageUrl: (state) => {
    return state.imageUrl;
  },
  multipleImage: (state) => {
    return state.multipleImage;
  },
  multipleImage2: (state) => {
    return state.multipleImage2;
  },
  thumbUrl: (state) => {
    return state.thumbUrl;
  },
  fileUrl: (state) => {
    return state.fileUrl;
  },
  videoUrl: (state) => {
    return state.videoUrl;
  },
  soundUrl: (state) => {
    return state.soundUrl;
  },
  url: (state) => {
    return state.url;
  },

  addUploaderCheck: (state) => {
    return state.addUploaderCheck;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },

  setImageUrl(state, data) {
    state.imageUrl = data;
  },
  setMultipleImageUrl(state, data) {
    state.multipleImage = data;
  },
  setMultipleImageUrl2(state, data) {
    state.multipleImage2 = data;
  },
  setThumbUrl(state, data) {
    state.thumbUrl = data;
  },
  setFileUrl(state, data) {
    state.fileUrl = data;
  },
  setVideoUrl(state, data) {
    state.videoUrl = data;
  },
  setSoundUrl(state, data) {
    state.soundUrl = data;
  },
  setUrl(state, data) {
    state.url = data;
  },
  setUrlsEmpty(state) {
    state.imageUrl = [];
    state.thumbUrl = [];
    state.fileUrl = [];
    state.videoUrl = [];
    state.soundUrl = [];
    state.url = [];
    state.multipleImage = [];
  },
  setAddUploaderCheck(state, data) {
    state.addUploaderCheck = data;
  },
  ///////////////////////////////////////////////////
  userProfile: (state) => {
    return state.userProfile;
  },

  fiscalYear: (state) => {
    return state.fiscalYear;
  },
};
